export default "__VITE_ASSET__D_SGTA7B__"